import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import HeadSub from '../../../../components/comm/HeadSub';
import URL from "../../../../constants/url";
import style from './NonContactMedicalCover.module.css';
import coverStartImg from '../../../../images/user/i_non_contact_cover_start.svg';
import coverEndImg from '../../../../images/user/i_non_contact_cover_end.svg';


const NonContactMedicalCover = () => {
    const navigate = useNavigate();

    return (
        <>
            <HeadSub title="비대면 진료" />
            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">


                    <div className={style['mid-box']}>
                        <div className='animation-2'>
                            <div className={style['top']}>
                                <div className={style['img-box']}>
                                    <object data={coverStartImg} alt="비대면 진료를 시작합니다." aria-hidden='true'></object>
                                    {/* <object data={coverEndImg} alt="비대면 진료가 종료되었습니다."></object> */}
                                </div>

                                <strong>비대면 진료를 시작합니다.</strong>  
                                <span>아래 주의사항을 확인하시고 입장해주세요.</span>

                                {/* <strong>비대면 진료가 종료되었습니다.</strong>  
                                <span>아래 주의사항을 확인하시고 <br />
                                    진료비 수납 후 처방전을 확인해주세요!
                                </span> */}

                            </div>

                            <div className={style['botm']}>
                                <p>비대면 진료 전 주의사항</p>
                                <ul>
                                    <li>
                                        <p>본 비대면 진료는 ZOOM 화상 서비스를 통해 진행됩니다.</p>
                                    </li>
                                    <li>
                                        <p>통신문제로 접속 또는 끊김 등의 문제가 있을 수 있으니 안정된 통신환경에서의 사용을 권장합니다.</p>
                                    </li>
                                    <li>
                                        <p>진료로 발생되는 진료 화상, 음성 데이터는 진료 안정성 확보 및 의료 분쟁 예방 등의 목적으로 서버에 30일간 임시 보관되며 자동 폐기됩니다.</p>
                                    </li>
                                    <li>
                                        <p>모든 환자 정보 및 기록은 법령이 허용하는 범위 내에서만 접근이 가능하며, 진료 목적 외 용도로는 사용되지 않습니다.</p>
                                    </li>
                                </ul>
                            </div>


                            {/* 비대면 진료 후 주의사항  */}
                            {/* <div className={style['botm']}>
                                <p>비대면 진료 후 주의사항</p>
                                <ul>
                                    <li>
                                        <p>진료 결과에 따라 의사가 판단한 경우에만 처방전이 발급됩니다.</p>
                                    </li>
                                    <li>
                                        <p>약 수령은 본인·대리 수령만이 가능합니다.</p>
                                    </li>
                                    <li>
                                        <p>약사는 구두 및 서면으로 복약지도를 제공하며, 복약 주의사항을 반드시 숙지해야 합니다.</p>
                                    </li>
                                    <li>
                                        <p>진료 후 증상 악화 또는 의사의 내원 권고 시, 빠른 시일 내에 의료기관을 방문해야 합니다.</p>
                                    </li>
                                    <li>
                                        <p>처방전은 7일 후 만료됩니다</p>
                                    </li>
                                </ul>
                            </div> */}

                        </div>
                    </div>



                    {/* 하단 다음 버튼 영역 :: S */}
                    <div className="bottom-fixed-box">
                        <div className="inner-box">
                            <div className='btn-layout' data-btn-num="1">

                                <button className="btn" data-btn-type="fill-main" data-btn-size="lg">
                                    <span>입장하기</span>
                                </button>

                                {/* <button className="btn" data-btn-type="fill-main" data-btn-size="lg">
                                    <span>닫기</span>
                                </button> */}

                            </div>
                        </div>
                    </div>
                    {/* 하단 다음 버튼 영역 :: E */}

                </div>
            </div>

        </>
    )
}

export default NonContactMedicalCover
